import { Injectable, inject, signal } from '@angular/core';

import { CookieAccess } from './cookie-access';

const LEGACY_ACCESS_KEY = 'fisital_access_token';
const LEGACY_REFRESH_KEY = 'fisital_refresh_token';

export const REFRESH_COOKIE = 'fisital_refresh_token';
/** 24 h, espelha o fv-dsh. */
const REFRESH_COOKIE_MAX_AGE_S = 60 * 60 * 24;

export function buildRefreshCookie(
  value: string,
  maxAgeSeconds: number = REFRESH_COOKIE_MAX_AGE_S,
): string {
  return `${REFRESH_COOKIE}=${encodeURIComponent(value)}; max-age=${maxAgeSeconds}; path=/; secure; samesite=strict`;
}

export function buildExpiredRefreshCookie(): string {
  return `${REFRESH_COOKIE}=; max-age=0; path=/; secure; samesite=strict`;
}

export function readCookieValue(cookieString: string, name: string): string | null {
  for (const part of cookieString.split(';')) {
    const trimmed = part.trim();
    const eq = trimmed.indexOf('=');
    if (eq > 0 && trimmed.slice(0, eq) === name) {
      return decodeURIComponent(trimmed.slice(eq + 1));
    }
  }
  return null;
}

/** Único dono dos tokens: access em memória, refresh em cookie estrito. */
@Injectable({ providedIn: 'root' })
export class TokenStore {
  private readonly cookies = inject(CookieAccess);
  private readonly accessToken = signal<string | null>(null);
  private generationCounter = 0;

  /** Muda a cada clear(); trabalho assíncrono antigo compara e se descarta. */
  get generation(): number {
    return this.generationCounter;
  }

  getAccessToken(): string | null {
    return this.accessToken();
  }

  setAccessToken(token: string): void {
    this.accessToken.set(token);
  }

  getRefreshToken(): string | null {
    return readCookieValue(this.cookies.read(), REFRESH_COOKIE);
  }

  setRefreshToken(token: string): void {
    this.cookies.write(buildRefreshCookie(token));
  }

  clear(): void {
    this.generationCounter++;
    this.accessToken.set(null);
    this.cookies.write(buildExpiredRefreshCookie());
  }

  /** Migração única: refresh legado do localStorage vira cookie; access é descartado. */
  migrateLegacyStorage(): void {
    const legacyRefresh = localStorage.getItem(LEGACY_REFRESH_KEY);
    if (legacyRefresh) {
      this.setRefreshToken(legacyRefresh);
    }
    localStorage.removeItem(LEGACY_REFRESH_KEY);
    localStorage.removeItem(LEGACY_ACCESS_KEY);
  }
}
